import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300/60 text-xs font-semibold text-primary-600 bg-primary-50/50 whitespace-nowrap">
            分类浏览
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
            探索你喜欢的漫画类型
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            从甜蜜恋爱到热血战斗，八大分类满足你的各种阅读口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:bg-primary-50/50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-500 transition-colors duration-300`} />
              </div>
              <h3 className="mt-4 text-base font-bold font-heading text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400">
                  {cat.count} 部作品
                </span>
                <i className="ri-arrow-right-line text-xs text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all duration-300" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}